import React from 'react'
import ShowDetailsComponent from '../../../Components/ShowComponent/ShowDetailsComponent';
import { useNavigate, useParams } from 'react-router-dom';

const ShowDetails = (props) => {
    let navigate = useNavigate();
    const params = useParams();

    return (
        <div>
            <ShowDetailsComponent {...props} navigate={navigate} id={params.id} />
        </div>
    );
}

export default ShowDetails